// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var UploadURL = function (x) {
    return x;
};
var tsBridgeUploadURL = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("UploadURL")("__brandUploadURL"));
    }
};
var writeUploadURL = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showUploadURL = Data_Show.showString;
var readUploadURL = Simple_JSON.readString;
var ordUploadURL = Data_Ord.ordString;
var newtypeUploadURL = {
    Coercible0: function () {
        return undefined;
    }
};
var makeUploadURL = UploadURL;
var eqUploadURL = Data_Eq.eqString;
export {
    UploadURL,
    makeUploadURL,
    unwrap,
    newtypeUploadURL,
    eqUploadURL,
    ordUploadURL,
    showUploadURL,
    readUploadURL,
    writeUploadURL,
    tsBridgeUploadURL
};
//# sourceMappingURL=index.js.map
